import React from 'react';
import { useRecentSessions } from './api';
import { LoadingState } from '../../components/common/LoadingState';
import { ApiErrorFallback } from '../../components/common/ApiErrorFallback';
import { EmptyState } from '../../components/common/EmptyState';
import { ActivityFeedItem } from './ActivityFeedItem';

export function ActivityFeed() {
  const { data, isLoading, error, refetch } = useRecentSessions();

  if (isLoading) {
    return <LoadingState message="Loading recent activity..." />;
  }

  if (error) {
    return <ApiErrorFallback error={error} onRetry={refetch} />;
  }

  if (!data || data.sessions.length === 0) {
    return (
      <EmptyState 
        title="No Recent Activity"
        description="Once sessions are completed, they will appear here."
      />
    );
  }

  return (
    <div className="space-y-4">
      {data.sessions.map((session: any) => (
        <ActivityFeedItem key={session.id} session={session} />
      ))}
    </div>
  );
}